export default {"src":"/_next/static/media/Purple_external_icon.0871352d.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};